var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeRel5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3575 17.4145C29.6512 17.1457 30.0422 16.9971 30.4478 17C30.8534 17.003 31.2419 17.1573 31.5314 17.4303C31.8209 17.7033 31.9887 18.0737 31.9995 18.4634C32.0102 18.8531 31.863 19.2315 31.5889 19.5188L23.2681 29.5196C23.125 29.6677 22.9523 29.7866 22.7603 29.8691C22.5684 29.9515 22.3611 29.996 22.1508 29.9997C21.9406 30.0035 21.7317 29.9664 21.5367 29.8908C21.3416 29.8152 21.1645 29.7026 21.0158 29.5597L15.4978 24.2567C15.3441 24.1191 15.2209 23.9531 15.1354 23.7687C15.0499 23.5844 15.0039 23.3853 15.0002 23.1835C14.9965 22.9817 15.0352 22.7812 15.1138 22.594C15.1925 22.4069 15.3096 22.2368 15.4581 22.0941C15.6066 21.9514 15.7835 21.8388 15.9783 21.7632C16.173 21.6876 16.3816 21.6505 16.5917 21.6541C16.8017 21.6576 17.0088 21.7018 17.2006 21.784C17.3925 21.8661 17.5652 21.9846 17.7083 22.1323L22.0752 26.327L29.3179 17.4586C29.3309 17.4431 29.3427 17.4284 29.3575 17.4145Z",
    fill: "#399948"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeRel5);
export default __webpack_public_path__ + "static/media/icone-rel-5.ed539c91f3dd8734792bdda7ac962b5b.svg";
export { ForwardRef as ReactComponent };